const VideoThumbnailSkeleton = () => (
    <div className="animate-pulse flex flex-col gap-2">
        <div className="aspect-video bg-slate-300 rounded w-full" />
        <div className="flex items-center justify-center">
            <div className="mx-4 text-base z-10 h-6 bg-slate-300 w-4/5 rounded"></div>
        </div>
    </div>
);

export default VideoThumbnailSkeleton;